<template>
  <div
    v-if="hideBidsText"
    class="no-bids white h5-headline text-start pa-10 black--text"
    data-qa="hide-bids-text">
    {{ hideBidsText }}
  </div>
  <div
    v-else-if="!offerBids || !offerBids.length || (!filtred_bid_groups || !filtred_bid_groups.length)"
    class="no-bids white h5-headline text-start pa-10 black--text">
    {{ offersSearch ? $t('Common.NoResultsForSearch') : $t('Tenders.NoBids') || $t('Tenders.NoBidsAuction') }}
  </div>
  <v-skeleton-loader
    v-else-if="load_criteryCard"
    :boilerplate="false"
    class="mt-4"
    :tile="false"
    type=" table-thead, table-tbody, table-tbody"
    width="100%"/>
  <OffersGroups
    v-else
    ref="offers_groups"
    :bid_groups="filtred_bid_groups"
    :bids="offerBids"
    :can_expand="offers_view.value != 'ALL'"
    :change_winner_mode.sync="change_winner_mode"
    :contranct-props="contranctProps"
    :critery-card="criteryCard"
    :group_types="offers_view_types"
    :grouped_by.sync="offers_view"
    :infinity_selector="infinity_selector"
    :only_review="only_review"
    :select="select"
    :tab="tab"
    :tender="tender"
    with_header
    @applyOfferSearch="createBid"
    @update:selected="updSelected"/>
</template>
<script>
import OffersGroups from 'components/tenders/tender page/OffersGroups.vue'

import { modalMixin, tenderMixin } from 'mixins'
import { eventBus } from '@/main'
import debounce from 'lodash/debounce'

import AiApi from '@/api/aiApi'
const aiApi = new AiApi()

export default {
  name: 'offersTab',
  mixins: [ tenderMixin, modalMixin ],
  data() {
    return {
      offersSearch: '',
      tenderRequirements: [],
      filtred_bid_groups: [],
      bid_groups: [],
      offers_view: {text: '', value: '', groupBy: () => {},
        positionValue: '',
        isGroup: false
      },
      currencies: [],
      selected_items: [],
      offerBids: [],
    }
  },
  props: {
    tender: Object,
    load_criteryCard: Boolean,
    criteryCard: Object,
    change_winner_mode: Boolean,
    tab: Object,
    mapGroups: Function,
    mapBids: {
      type: Function,
      default: val => val
    },
    /** функція вибору  */
    select: {
      type: Function
    },
    /*
      тільки перегляд - без редагування і переходу
    */
    only_review: {
      type: Boolean,
      default: false
    },
    /*
      тільки активні пропозиції ( .bidStatus == 'ACTIVE' )
    */
    only_active: {
      type: Boolean,
      default: false
    },
    infinity_selector: String,
    contranctProps: {
      type: Object
    }
  },
  async created() {
    this.$root.$on('updateSupplierVerification', this.updateSupplierVerification)
    this.getRequirement()
    
    await this.$store.dispatch('setCurrencies')
      .then(res => this.currencies = res)
    
    eventBus.$on('offerTab_getRequirements', this.eventQetRequirements)
    this.$root.$on('offerTab_changeWinnerState', this.setOfferSearch)
    this.$root.$on('offerTab_createBid', this.createBid)

    this.updateOffersView()
  },
  beforeDestroy() {
    eventBus.$off('offerTab_getRequirements', this.eventQetRequirements)
    this.$root.$off('updateSupplierVerification', this.updateSupplierVerification)
    this.$root.$off('offerTab_changeWinnerState', this.setOfferSearch)
    this.$root.$off('offerTab_createBid', this.createBid)
  },
  computed: {
    hideBidsText() {
      const status = this.tender?.tenderStatus?.id
      const bidsCount = this.tender?.bids?.length || 0
      const hideProposals = this.settings?.tenderSettings?.hideProposalsUntilRemoveTenderFromSite

      if (hideProposals) {
        if (status === this.statuseKeys.SUBMISSION) { // Прийом пропозицій
          return this.$t('Tenders.HideBids')
        } else if (status === this.statuseKeys.AUCTION) { // Аукціон
          return this.$t('Tenders.HideBidsAuction')
        } else if (bidsCount === 0) {
          return this.$t('Tenders.NoBids')
        }
        // Інші статуси з bidsCount > 0 - пустая ячейка
        return null
      } else {
        if (bidsCount === 0) {
          return this.$t('Tenders.NoBids')
        }
        return null
      }
    },
    offers_view_types() {
      let views = [
        { text: `${this.$t('Purchasing.All')} ${this.smallFirstLetter(this.$t('Tenders.Offers'))}`, value: 'ALL' },
        { text: this.$t('Tenders.ByLots'), value: 'lotId', header_value: 'lotTitle' },
        { text: this.$t('Tenders.ByParticipants'), value: 'participant', header_value: 'name'},
      ]
      let prequalification = this.tender.tenderStatus?.id == this.statuseKeys.PREQUALIFICATION,
        cancelled = this.tender.tenderStatus?.id == this.statuseKeys.PURCHASE_NOT_PLACED,
        ended = this.tender.tenderStatus?.id == this.statuseKeys.COMPLETED,
        analis = this.tender.tenderStatus?.id == this.statuseKeys.BID_ANALYSIS,
        frame = this.tender?.biddingType?.isFrameFirstStage

      if ((ended && !frame) || analis || (cancelled && this.change_winner_mode)) {
        views.push({ text: this.$t('Tenders.Winners'), value: 'selectedBid' })
      }
      if (prequalification || (ended && frame)) {
        views.push({ text: this.$t('Tenders.PrequalificationStatus'), value: 'prequalification_status', groupBy: (item) => item.prequalification?.status })
      }

      if (this.$_isGroupEnabled) {
        views.push({ text: `${this.$t('Tenders.ByLots')} (${this.$tc('Common.position', 3)})`,
          value: 'lotGroupNumber',
          positionValue: 'participant',
          isGroup: true,
          component: 'OffersGroupTable',
          type: 'bySupplier',
        })
        views.push({ text: `${this.$t('Tenders.ByParticipants')} (${this.$tc('Common.position', 3)})`,
          value: 'participant',
          positionValue: 'lotGroupNumber',
          isGroup: true,
          component: 'OffersGroupTable',
          type: 'byLot',
        })
        if ((ended && !frame) || analis || (cancelled && this.change_winner_mode)) {
          views.push({ text: `${this.$t('Tenders.Winners')} (${this.$tc('Common.position', 3)})`,
            value: 'selectedBid',
            positionValue: (item) => `${item.participant}_${item.lotGroupNumber}_${item.lotGroupTitle}`,
            isGroup: true,
            component: 'OffersGroupTable',
            type: 'byWinners',
          })
        }
      }

      return views
    },
    isGroupLogic() {
      return this.offers_view?.isGroup
    },
  },
  methods: {
    eventQetRequirements(params) {
      if (params.tenderId !== this.tender?.tenderId) {
        return 
      }
      this.$set(this, 'tenderRequirements', [])
      this.getRequirement()
    },
    getRequirement() {
      return new Promise((resolve) => {
        aiApi.getParticipantAssessments(this.tender?.tenderId)
          .then((result) => {
            this.$set(this, 'tenderRequirements', result?.suppliers ?? [])
            this.createBid()
            resolve()
          })
      })
    },
    updateSupplierVerification(props) {
      this.$_updateSupplierVerification(props)
        .then(() => {
          this.createBid()
        })
    },
    createBid: debounce(async function () {
      await this.$_setCrmSupplierVerificationByTender(this.tender?.bids)

      let allBids = this.getBids(this.tender?.bids, this.tender, false, this.mapBids)

      allBids?.forEach(bid => {
        bid.requirements = this.$_.find(this.tenderRequirements, req => req.supplierId === bid.bidderInfo.organizationId)
      })

      this.$_setContracts(allBids)
        .then(() => {
          this.offerBids = this.$_.filter(allBids, bid => {
            let statuses = ['ACTIVE']
            if (!this.only_active) {
              statuses.push('DRAFT')
            }
            return statuses.includes(bid.bidStatus)
          })
          this.applyOfferSearch(this.offersSearch)
        })
    }, 250),
    setOfferSearch(elements) {
      elements.forEach(element => {
        this.tender.bids.forEach(bid => {
          const selectedBid = bid.bidDetails.find(b => b.id === element.id)
          if (selectedBid) {
            selectedBid.selectedBid = element.selectedBid
            if ( !element.selectedBid ) {
              selectedBid.selectedQuantity = selectedBid.quantity
            }
          }
        })
      })
      this.bid_groups.forEach((bid_group) => {
        bid_group.selected = []
      })
      this.selected_items = []
      this.applyOfferSearch()
    },
    updateOffersView() {
      this.$nextTick(() => {
        this.offers_view = this.offers_view_types.find( el => el.value == 'selectedBid' || el.value == 'prequalification_status' ) || this.offers_view_types[0]
      })
    },
    getLotPositionsBidGroups() {
      const groups = this.offers_view.groupBy || this.offers_view.value
      if (this.offers_view?.isGroup) {
        this.bid_groups = this.$_getGroupsPositionsByLot(this.offerBids, this.offers_view)
        return
      }
      this.bid_groups = this.getGroups(this.offerBids, groups)
      return
    },
    getBidGroups() {
      if (this.isGroupLogic) {
        return this.getLotPositionsBidGroups()
      }
      let groupBy = this.offers_view.groupBy || this.offers_view.value
      let groups = groupBy == 'selectedBid' ? this.$_getGroupsByWinners(this.offerBids) : this.getGroups(this.offerBids, groupBy )

      groups.forEach((gr, index) => {
        gr.order = index  + 1
        if ( this.tender.tenderStatus?.id == 3 ) {
          gr.formatHeaders = (headers) => {
            headers[3].text = this.$t('Tenders.SelectedQuantity')
            return headers
          }
        }
        if ( this.offers_view.value == 'ALL' ) {
          gr.title = this.offers_view.text
        }
        if ( this.offers_view.value == 'lotId' ) {
          if (gr.items[0].lotGroupTitle) {
            gr.order = (gr.items[0].lotGroupNumber * 10) + (gr.items[0].lotNumber || index  + 1)
            gr.title = gr.items[0].lotTitle
            gr.groupTitle = gr.items[0].lotGroupTitle
          } else {
            gr.order = gr.items[0].lotNumber || index  + 1
            gr.title = gr.items[0].lotTitle
          }
          gr.subtitle = gr.items[0]?.unit?.title
        }
        if (this.offers_view.value == 'participant') {
          gr.title = `#${index  + 1 } ${gr.items[0].name}`
          gr.winners = true
        }
        if ( this.offers_view.header_value ) {
          gr.formatHeaders = (headers) => {
            return headers = headers.filter(el => el.value != this.offers_view.header_value)
          }
        }
        if ( this.offers_view.value == 'prequalification_status' ) {
          gr.id = gr.title
          gr.title = this.$t('Tenders.prequalified.' + gr.title)
          if ( !this.$can('hide', 'PricesOnPrequalification') ) {
            gr.winners = true
          }

        }
        gr.selected = this.selected_items.filter(sel => gr.items.some(it => it.id == sel.id))
      })
      if (this.offers_view.value == 'prequalification_status' ) {
        groups = groups.sort(a => {
          return a.id == 'PENDING' || a.id == 'ACTIVE' ? -1 : 1
        })
      } else {
        groups = groups.sort((a, b) => a.order - b.order)
      }
      if (this.mapGroups) {
        groups = this.mapGroups(groups, groupBy)
      }
      this.bid_groups = groups
    },
    applyOfferSearch(search) {
      this.getBidGroups()
      this.offersSearch = search ?? this.offersSearch
      this.filtred_bid_groups = this.bid_groups.map(el => (
        {...el, items: el.items.slice(0)
          .sort((a, b) => a.lotNumber - b.lotNumber)
        }
      ))

      if  ( !this.offersSearch?.length ) {
        return
      }
      this.filtred_bid_groups = this.filtred_bid_groups.filter(el => {
        el.items = el.items?.filter(item => {
          let includes = (text) => text?.toLowerCase().includes(this.offersSearch?.toLowerCase())
          return includes(item.lotTitle) || includes(item.name)
        })
          .sort((a, b) => a.lotNumber - b.lotNumber)
        return el.items?.length
      })
    },
    updSelected(its) {
      this.selected_items = its
      this.$emit('update:selected', its )
    }
  },
  watch: {
    tender: {
      deep: true,
      handler(newValue, oldValue) {
        if (!oldValue || JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
          this.$store.dispatch('setCurrencies')
            .then(res => {
              this.currencies = res
              this.createBid()
            })
        }
      }
    },
    offers_view() {
      if (!this.tab || this.tab.value == 'offers') {
        this.applyOfferSearch()
      }
    },
  },
  components: {
    OffersGroups
  }
}
</script>
<style lang="scss" scoped>
  .no-bids {
    height: 160px;
    width: 100%;
    border-radius: 8px;
  }
</style>
